import CliniciansModal from './CliniciansModal';

export default CliniciansModal;
